<template>
    <div :class="theme === 'LIGHT' ? 'bg-white' : 'bg-[#191919] text-white'">
        <div class="text-center my-12" v-if="title">
            <h2 class="text-3xl font-medium">{{ title }}</h2>
        </div>

        <Carousel :totalItems="articles.length" :theme="theme" v-slot={index,key}>
            <ArticleCard class="md:w-[240px]" :key="key" v-bind="articles[index]"/>
        </Carousel>
    </div>
</template>

<script setup lang="ts">
import Carousel from '~/components/ui/molecule/carousel/index.vue'
import ArticleCard, {type ArticleCardProps} from '~/components/ui/organism/article/card.vue'

interface ArticleCarouselProps {
    title?: string;
    articles: ArticleCardProps[];
    theme: "DARK" | "LIGHT";
}

const {articles=[], theme="LIGHT", title} = defineProps<ArticleCarouselProps>();

</script>